module.exports = __webpack_public_path__ + "img/thumbnail_IndianPeafowl_f_albino.f64c9be5.png";